import * as types from '../mutations';
export default {
	namespaced: true,

	state: {
		lessons: []
	},

	actions: {
		fetchAll({ rootState, commit }, { fromDate, toDate }) {
			return window.axios.get(`center/${rootState.login.activeUser.centerId}/students/${rootState.login.activeUser.userName}/get-lessons`, {
				params: { fromDate, toDate }
			}).then(({ data }) => {
				commit(types.STORE_LESSONS, data);
				return data;
			})
		},

		clear({ commit }) {
			commit('CLEAR')
		}
	},

	mutations: {
		[types.STORE_LESSONS](state, lessons) {
			state.lessons = lessons;
		},

		CLEAR(state) {
			state.lessons = [];
		}
	},

	getters: {
		getLessonById: state => id => state.lessons.find(c => c.id === id)
	}
}